export const filterUsersByLocation = (location, users) => {
  if (!location || location === 0) {
    return users;
  }

  return users.filter(user => user.locations.includes(location));
};
